module.exports = __webpack_public_path__ + "static/media/015.63e34f06.jpg";